// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-upload[data-v-8b5332aa]{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.upload-btn[data-v-8b5332aa]{background-color:#20b2aa;color:#fff;border-radius:15px;padding:10px;cursor:pointer;width:100%;text-align:center;margin-block:20px}.upload-btn[data-v-8b5332aa]:hover{background-color:#fff;color:#20b2aa;border:1px solid #20b2aa}", ""]);
// Exports
module.exports = exports;
